export function customForm() {
    const $pageTitle = $(".next-custom-form");
    const $pageTitleContainer = $pageTitle.find(".container");
    const $customForm = $(".custom-form");
    const $window = $(window);
    let containerOffset;
    let $pageTitleHeight;
    let $customFormHeight;

    function formTop() {
        if ($window.innerWidth() >= 1024) {
            containerOffset = $pageTitleContainer.offset().top;
            $pageTitleHeight = $pageTitle.innerHeight();
            $customFormHeight = $customForm.innerHeight();
            console.log($customFormHeight > $pageTitleHeight - containerOffset);
            console.log($customFormHeight);
            console.log($pageTitleHeight - containerOffset);
            if ($customFormHeight > $pageTitleHeight - containerOffset) {
                $customForm.parent().removeClass("small-indent");
                $customForm.css({
                    "margin-top": -($pageTitleHeight - containerOffset)
                })
            } else {
                $customForm.parent().addClass("small-indent");
            }
        } else {
            $customForm.removeAttr("style");
        }
    }

    $window.on("load resize", function () {
        formTop();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customForm.js